module.exports = __webpack_public_path__ + "img/20220415_100939.bb14f1d2.jpg";